__turbopack_context__.v({
  "desktop": "syqXNG_desktop",
  "mobile": "syqXNG_mobile",
  "placeholder": "syqXNG_placeholder",
  "video": "syqXNG_video",
});
